module.exports = __webpack_public_path__ + "static/media/Icon_1024.fa43299b.png";